import store from '@src/store';
import history from '@src/history';
import { REFETCH_CUSTOMER_DATA } from '@src/app/login/weak/actions';

export const RESUME_START = 'RESUME_START';
export const RESUME_SUCCESS = 'RESUME_SUCCESS';
export const RESUME_ERROR = 'RESUME_ERROR';
export const RESUME_LOADING = 'RESUME_LOADING';
export const RESUME_CANCEL = 'RESUME_CANCEL';

export type Actions = {
  RESUME_START: { type: typeof RESUME_START; payload: boolean };
  RESUME_LOADING: { type: typeof RESUME_LOADING; payload: boolean };
  RESUME_SUCCESS: { type: typeof RESUME_SUCCESS; payload: any };
  RESUME_ERROR: { type: typeof RESUME_ERROR; payload: any };
  RESUME_CANCEL: { type: typeof RESUME_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  resumeStart: (payload: any): Actions[typeof RESUME_START] => ({
    type: RESUME_START,
    payload,
  }),
  resumeError: (payload: any): Actions[typeof RESUME_ERROR] => ({
    type: RESUME_ERROR,
    payload,
  }),
  resumeSuccess: (payload: any): Actions[typeof RESUME_SUCCESS] => {
    // store.dispatch({type: REFETCH_CUSTOMER_DATA, payload: payload.refetchCustomerPayload});
    store.dispatch({type: RESUME_LOADING, payload: true});
    if (payload && payload.payload[0] && payload.payload[0].directResume) {
      // We resumed 1 sub directly without going to the Resume All view.  Need to route differently to the cfm page.
      payload.payload[0].history.push('/accounts/resume');
    }
    return ({ type: RESUME_SUCCESS, payload: payload});
  },
  resumeLoading: (payload: boolean): Actions[typeof RESUME_LOADING] => ({
    type: RESUME_LOADING,
    payload,
  }),
  resumeCancel: (payload: boolean): Actions[typeof RESUME_CANCEL] => ({
    type: RESUME_CANCEL,
    payload,
  }),

};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/resume/actions.ts